import { render, staticRenderFns } from "./RegisterForAdult.vue?vue&type=template&id=6f24fe74&scoped=true"
import script from "./RegisterForAdult.vue?vue&type=script&lang=js"
export * from "./RegisterForAdult.vue?vue&type=script&lang=js"
import style0 from "./RegisterForAdult.vue?vue&type=style&index=0&id=6f24fe74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f24fe74",
  null
  
)

export default component.exports